import { EmailAddress } from '@dreryk/email-address-common-api';

import { commonTranslationKeys, FieldControllerProps } from '@dreryk/react-common';
import { ClassNameProp, EmailAddressInput as EmailAddressInputComponent } from '@dreryk/react-components';

type EmailAddressInputProps = FieldControllerProps<'emailAddress', EmailAddress | null> & ClassNameProp;

export const EmailAddressInput = (props: EmailAddressInputProps): JSX.Element => {
   const controller = props.register(props.name, {
      required: props.required,
   });

   return (
      <EmailAddressInputComponent
         testId={props.name}
         label={commonTranslationKeys.email}
         controller={controller}
         className={props.className}
      />
   );
};
